const FUNDRAISING_CLUSTER = {
    mini_site: {
        logo: {
            url: '/nonprofits/fundraising',
            alt: 'monday.com for fundraising',
            src: 'https://dapulse-res.cloudinary.com/image/upload/mondayhomepage/mini-site/fundraising/56.png',
            mobileSrc: 'https://dapulse-res.cloudinary.com/image/upload/mondayhomepage/mini-site/fundraising/fundraising_mobile_logo.png',
            useDesktopLogoInMobile: 'true',
        },
        links: [
            {
                url: '/nonprofits/fundraising',
                text: 'minisite.header.overview',
                removeFromUnified: 'true',
            },
            {
                url: '/nonprofits/fundraising/eligibility',
                text: 'minisite.header.eligibility',
            },
            {
                url: '/nonprofits/fundraising/pricing',
                text: 'minisite.header.pricing',
                isPricingPage: 'true',
            },
        ],
        unifiedDesktopLogo: {
            alt: 'monday.com for fundraising',
            src: 'https://dapulse-res.cloudinary.com/image/upload/mondayhomepage/mini-site/fundraising/monday_fundraising_logo_unify.png',
            url: '/nonprofits/fundraising',
        },
    },
    payments_view: {
        pricing: {
            discount: {
                value: '0.7',
                valid_tiers: ['pro'],
                valid_periods: ['yearly'],
                hide_crossed_out_discount: 'true',
            },
            sections: [
                {
                    section: 'CUSTOMER_FAVORITES',
                    overrides: {
                        features: [
                            { feature: 'UNLIMITED_BOARDS' },
                            { feature: 'TEMPLATES' },
                            { feature: 'COLUMN_TYPES' },
                            { feature: 'UNLIMITED_VIEWERS' },
                            { feature: 'FORMS' },
                            { feature: 'MOBILE' },
                            { feature: 'IMPORT_FROM_OTHER_TOOLS' },
                            { feature: 'TIMELINE' },
                            { feature: 'PRIVATE_BOARDS' },
                            {
                                feature: 'AUTOMATIONS',
                                overrides: {
                                    tiers: {
                                        pro: 'pricingPage.features.plans.automations_enterprise',
                                    },
                                },
                            },
                        ],
                    },
                },
                {
                    section: 'COLLABORATION',
                    overrides: {
                        features: [
                            { feature: 'UNLIMITED_VIEWERS' },
                            { feature: 'EMBEDDED_BOARD' },
                            { feature: 'WHITEBOARD' },
                            { feature: 'UPDATES_SECTION' },
                            { feature: 'ZOOM_INTEGRATION' },
                            { feature: 'GUESTS' },
                            {
                                feature: 'STORAGE',
                                overrides: {
                                    tiers: {
                                        pro: 'pricingPage.features.plans.storage_enterprise',
                                    },
                                },
                            },
                        ],
                    },
                },
                {
                    section: 'PRODUCTIVITY',
                    overrides: {
                        features: [
                            { feature: 'MOBILE' },
                            { feature: 'FORMS' },
                            { feature: 'CUSTOMIZABLE_NOTIFICATIONS' },
                            {
                                feature: 'INTEGRATIONS',
                                overrides: {
                                    tiers: {
                                        pro: 'pricingPage.features.plans.integrations_enterprise',
                                    },
                                },
                            },
                            {
                                feature: 'AUTOMATIONS',
                                overrides: {
                                    tiers: {
                                        pro: 'pricingPage.features.plans.automations_enterprise',
                                    },
                                },
                            },
                            { feature: 'PREMIUM_INTEGRATIONS' },
                            { feature: 'TIME_TRACKING' },
                            { feature: 'FORMULA' },
                            { feature: 'DEPENDENCY_COLUMN' },
                        ],
                    },
                },
                {
                    section: 'VIEWS_AND_REPORTING',
                    overrides: {
                        features: [
                            {
                                feature: 'ACTIVITY_LOG',
                                overrides: {
                                    tiers: {
                                        pro: 'pricingPage.features.plans.five_years',
                                    },
                                },
                            },
                            {
                                feature: 'DASHBOARDS',
                                overrides: {
                                    tiers: {
                                        pro: 'pricingPage.features.plans.dashboards_enterprise',
                                    },
                                },
                            },
                            { feature: 'KANBAN_VIEW' },
                            { feature: 'TIMELINE' },
                            { feature: 'CALENDAR' },
                            { feature: 'MAP' },
                            { feature: 'CHART_VIEW' },
                            { feature: 'WORKLOAD' },
                        ],
                    },
                },
                { section: 'SUPPORT_NEW' },
                { section: 'SECURITY_AND_PRIVACY' },
                {
                    section: 'ADMINISTRATION_AND_CONTROL',
                    overrides: {
                        features: [
                            { feature: 'MAXIMUM_SEATS' },
                            { feature: 'BOARD_ADMINISTRATORS' },
                            { feature: 'SCIM' },
                            { feature: 'AUDIT_LOG' },
                            { feature: 'SESSIONS' },
                            { feature: 'PANIC_MODE' },
                            {
                                feature: 'PRIVATE_WORKSPACES',
                                overrides: {
                                    tiers: {
                                        pro: 'true',
                                    },
                                },
                            },
                            { feature: 'ACCOUNT_PERMISSIONS' },
                        ],
                    },
                },
                {
                    section: 'ADVANCED_REPORTING',
                    overrides: {
                        features: [
                            { feature: 'WORK_PERFORMANCE_INSIGHTS' },
                            { feature: 'SCHEDULED_DASHBOARD_DELIVERY' },
                            {
                                feature: 'PIVOT_ANALYSIS',
                                overrides: {
                                    tiers: {
                                        pro: 'true',
                                    },
                                },
                            },
                        ],
                    },
                },
            ],
            value_features: {
                pro: [
                    'PRIVATE_BOARDS',
                    'CHART_VIEW',
                    'TIME_TRACKING',
                    'FORMULA',
                    'DEPENDENCY',
                    'ENTERPRISE_SCALE_AUTOMATIONS',
                    'ENTERPRISE_DASHBOARDS',
                ],
                enterprise: [
                    'ENTERPRISE_GRADE_SECURITY',
                    'ADVANCED_REPORTING',
                    'MULTI_LEVEL_PERMISSIONS',
                    'TAILORED_ONBOARDING',
                    'PREMIUM_SUPPORT',
                ],
            },
            plans: {
                hidden_plans: ['free', 'basic', 'standard'],
                plan_overrides: {
                    pro: {
                        displayName: 'pricingPage.plans.npo.title',
                    },
                },
            },
            contact_us_threshold: '100',
            contact_us_links: {
                pro: 'https://forms.monday.com/forms/bdfbfc13ea752353200f5776d233db66?r=use1',
                enterprise: 'https://forms.monday.com/forms/bdfbfc13ea752353200f5776d233db66?r=use1',
            },
            tier_descriptions: {
                pro: 'pricingPage.tierDescriptions.npo.pro',
                enterprise: 'pricingPage.tierDescriptions.npo.enterprise',
            },
            periods: {
                hidden_periods: ['monthly'],
                display: {
                    price_display: 'yearly',
                },
            },
            most_popular: {
                forced_tier: 'pro',
                minimum_users_count: '11',
                text_for_forced_tier: 'pricingPage.plans.npo.discount',
            },
            users_count_options: {
                all_options: ['10', '13', '15', '20', '25', '30', '40', '50', '100', '200+'],
                free_options: ['3', '5', '10'],
            },
        },
    },
};

export { FUNDRAISING_CLUSTER };
